<div class="px-px-24 py-px-16">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-px-8">
    <h1 class="m-0 fs-24 fw-7">Comptes professionnels</h1>
    <app-button text="Actualiser" [stroked]="true" (handleClick)="load()"></app-button>
  </div>

  <div class="fs-13 text-neutral-dark-grey mb-px-16">
    Comptes créés par les professionnels eux-mêmes (application mobile / inscription en ligne).
    Tant qu'un compte n'est pas validé, le professionnel peut se connecter mais ne peut pas postuler aux missions.
    Les comptes créés par l'administrateur ou un collaborateur sont activés directement.
  </div>

  @if (loading) {
    <app-loader></app-loader>
  } @else if (loadError) {
    <div class="empty-state">La liste n'a pas pu être chargée. <a class="cursor-pointer text-action" (click)="load()">Réessayer</a></div>
  } @else if (rows.length === 0) {
    <div class="empty-state">Aucun compte professionnel en attente de validation.</div>
  } @else {
    <div class="pro-list">
      @for (a of rows; track a.id) {
        <div class="pro-card">
          <div class="pro-main">
            <div class="fw-7 fs-16">{{ fullName(a) }}</div>
            <div class="fs-13 text-neutral-dark-grey">{{ a.email }}</div>
            @if (a.phoneNumber) {
              <div class="fs-13 text-neutral-dark-grey">{{ a.phoneNumber }}</div>
            }
            <div class="fs-12 text-neutral-dark-grey mt-px-4">Inscrit le {{ date(a.createdAt) }}</div>
          </div>

          <div class="pro-profile">
            <div class="fs-12 text-neutral-dark-grey">Profil demandé</div>
            @if (a.fonction) {
              <div class="fw-6 fs-14">{{ profileLabel(a) }}</div>
              @if (a.poste) {
                <div class="fs-12 text-neutral-dark-grey">{{ a.poste }}</div>
              }
              <label class="fs-12 mt-px-8" [for]="'pro-status-' + a.id">Statut</label>
              <select class="form-select form-select-sm" [id]="'pro-status-' + a.id"
                      [(ngModel)]="a.selectedProStatus" [disabled]="a.busy">
                @for (o of statusOptionsFor(a); track o.value) {
                  <option [value]="o.value">{{ o.label }}</option>
                }
              </select>
            } @else {
              <div class="fs-13">Compte non-professionnel de santé</div>
            }
          </div>

          <div class="pro-actions">
            <app-button text="Valider" [disabled]="a.busy" (handleClick)="validate(a)"></app-button>
            <app-button text="Refuser" [stroked]="true" [disabled]="a.busy" (handleClick)="reject(a)"></app-button>
          </div>
        </div>
      }
    </div>
  }
</div>
